<div
  id="phoneId"
  class="position-relative mt-4 phone-input !mb-6"
  (mouseenter)="openBulkAction = false"
>
  @if (isIconShow) {
    <app-custom-icon icon="telephone" class="me-2"></app-custom-icon>
  }
  <div
    class="d-inline-block fw-500 text-1 align-top mb-1"
    [ngClass]="{ isIconShow: 'ms-2' }"
  >
    {{ 'COMMON.Phone Number' | translate }}
  </div>
  @if (phoneRequired) {
    <span class="color-6">*</span>
  }
  <div class="mt-2">
    @for (contact of businessContact; track contact; let i = $index) {
      <div
        class="flex gap-2"
        fxLayoutGap="10"
        [ngClass]="{
          'phone_div_resp xs-2:flex-col xs-2:!gap-3': moduleName == 'Contact',
          phone_div_resp_org: moduleName == 'Organization Contact',
        }"
      >
        @if (!notFromEQuoteOrg) {
          <div
            class="countryId"
            [ngClass]="{
              'w-[15%] countryId_resp xs-2:!w-full': moduleName == 'Contact',
              countryId_resp_org: moduleName == 'Organization Contact',
              '!w-[277px]': !notFromEQuote && !fields?.type?.length,
              '!w-[17%]': fields?.type?.length,
              responsive_div: moduleName == 'Organization Contact',
              resp_equote: isEquote,
            }"
          >
            <app-select-control
              [selectedId]="
                contact.countryId ? contact.countryId : contact?.country_code
              "
              [itemList]="countryListArr"
              [index]="i"
              [type]="'countryId'"
              [moduleName]="moduleName"
              [notFromEQuoteCountry]="notFromEQuote"
              (changeValue)="changephonenumberselect($event)"
            >
            </app-select-control>
          </div>
        }
        @if (notFromEQuoteOrg) {
          <div
            class="countryId"
            style="width: 25%"
            [ngClass]="{
              countryId_resp: moduleName == 'Contact',
              countryId_resp_org: moduleName == 'Organization Contact',
              '!w-[25%]': !notFromEQuote && !fields?.type?.length,
              '!w-[17%]': fields?.type?.length,
            }"
          >
            <app-select-control
              [selectedId]="
                contact.countryId ? contact.countryId : contact?.country_code
              "
              [itemList]="countryListArr"
              [index]="i"
              [type]="'countryIdOrg'"
              [moduleName]="moduleName"
              [notFromEQuoteCountryOrg]="notFromEQuoteOrg"
              (changeValue)="changephonenumberselect($event)"
            >
            </app-select-control>
          </div>
        }
        <div
          class="mobile_number mobile_number_name relative"
          [ngClass]="{
            'mobile_number_resp xs-2:!w-full': moduleName == 'Contact',
            mobile_number_org: moduleName == 'Organization Contact',
            '!w-[277px]': !notFromEQuote && !fields?.type?.length,
            '!w-[16%]': fields?.type?.length,
            responsive_div: moduleName == 'Organization Contact',
            resp_equote: isEquote,
          }"
        >
          <mat-form-field
            appearance="outline"
            [ngClass]="{
              'mat-error-outline': contact.phoneError,
              'mat-success-outline': !contact.phoneError,
            }"
          >
            <input
              style="padding-top: 3px"
              [ngClass]="{
                'border-red-500 animate-shake': showPhoneError,
                '!text-[14px]': isEquote,
                'fs-4-1 text-[15px]': !isEquote,
              }"
              matInput
              type="text"
              placeholder="{{ 'GENRIC_PLACEHOLDER.Number' | translate }}"
              appNumbersOnly
              name="mobile_number"
              [ngModel]="contact.mobile_number"
              (ngModelChange)="
                changephonenumberinput($event, i, 'mobile_number')
              "
            />
          </mat-form-field>
          <div
            class="remove-arrow text-3 w-fit xs-2:absolute xs-2:-right-[27px] xs-2:top-0 hide_arrow"
            [ngClass]="{
              'xs-2:-right-[45px]': moduleName == 'Organization Contact',
            }"
          >
            <button
              class="btn"
              type="button"
              (click)="removeItem(i, 'phonenumber')"
            >
              <p class="d-inline-block remove-contact-number">
                <i class="fas fa-times"></i>
              </p>
            </button>
          </div>
          @if (contact.phoneError) {
            <div class="text-red-600">Phone Number is Required</div>
          }
        </div>
        @if (fields?.type?.length || formContactListArr?.length) {
          <form
            [formGroup]="addContactForm"
            class="mobile_form mobile_number_name"
            style="margin-right: 10px !important"
            [ngClass]="{
              mobile_form_resp: moduleName == 'Contact',
              mobile_form_resp_org: moduleName == 'Organization Contact',
              '!w-[16%]': fields?.type?.length,
              responsive_div: moduleName == 'Organization Contact',
              'w-[33%]': moduleName == 'Business Contact',
              resp_equote: isEquote,
            }"
          >
            @if (flag == true && notFromEQuote && !notFromEQuoteOrg) {
              <div class="mobile_name">
                <mat-form-field
                  id="country"
                  class="number-width"
                  appearance="outline"
                  floatLabel="always"
                >
                  <mat-select
                    id="num_name"
                    class="text-1 fs-4-1 panel-width"
                    [placeholder]="
                      isEquote
                        ? ('COMMON.Select a Phone' | translate)
                        : ('COMMON.Select And Add Name' | translate)
                    "
                    (selectionChange)="addFormOfContact($event)"
                    [(ngModel)]="contact.name"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="changephonenumberinput($event, i, 'name')"
                  >
                    <mat-option class="text-1" value="">
                      {{
                        isEquote
                          ? ('COMMON.Select a Phone' | translate)
                          : ('CONTACT_PROFILE.Select_contact_name' | translate)
                      }}
                    </mat-option>
                    @for (
                      formContactList of formContactListArr;
                      track formContactList;
                      let i = $index
                    ) {
                      <mat-option
                        id="option_num"
                        class="text-1 d-flex align-items-center overflow-visible f-poppins"
                        [value]="formContactList.name"
                      >
                        <div
                          class="dropdown navbar text-right p-0 px-2"
                          style="background: transparent"
                        >
                          <button
                            class="menu-btn2 fs-2 text-right"
                            id="sideMenuDropDown"
                            aria-expanded="false"
                            (click)="openBulkActionPopup($event, i)"
                          >
                            <svg
                              width="25"
                              height="25"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="16.6802"
                                cy="11.9829"
                                r="1.46341"
                                fill="#03C0FC"
                              />
                              <circle
                                cx="11.9986"
                                cy="11.9829"
                                r="1.46341"
                                fill="#03C0FC"
                              />
                              <circle
                                cx="7.31693"
                                cy="11.9829"
                                r="1.46341"
                                fill="#03C0FC"
                              />
                              <circle
                                cx="12"
                                cy="12"
                                r="11.25"
                                stroke="#03C0FC"
                                stroke-width="1.5"
                              />
                            </svg>
                          </button>
                          @if (openBulkAction && currentIndex === i) {
                            <div
                              class="shadow-sm dropdown-menu bg-0 dropdown-1 flex-column gap-3 show"
                              aria-labelledby="sideMenuDropDown"
                              style="top: 85%"
                            >
                              <div class="px-2 flex flex-col gap-1">
                                <div
                                  class="flex items-center gap-3"
                                  (click)="
                                    removeItem(
                                      formContactList.id,
                                      'deleteformContact'
                                    )
                                  "
                                >
                                  <mat-icon class="vertical-align-baseline m-0">
                                    <img
                                      class="vertical-align-baseline"
                                      style="width: 25px; height: 20"
                                      role="button"
                                      src="assets/img/home/delete.svg"
                                    />
                                  </mat-icon>
                                  {{ 'COMMON.Delete' | translate }}
                                </div>
                                <div
                                  class="flex items-center gap-3 px-1"
                                  (click)="
                                    updateSubcategories(
                                      formContactList,
                                      formContactListArr
                                    )
                                  "
                                >
                                  <i
                                    class="fa fa-edit edit-icon"
                                    style="color: #03c0fc"
                                  ></i>
                                  {{ 'COMMON.Edit' | translate }}
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="w-max" (click)="openBulkAction = false">
                          {{
                            getTranslatedText(
                              'CONTACT_PROFILE.' + formContactList.name
                            ) || formContactList.name
                          }}
                        </div>
                      </mat-option>
                    }
                    <mat-option
                      style="margin-left: 13px"
                      class="text-1 f-poppins"
                      [value]="null"
                      (click)="triggerAddFormOfContact($event)"
                    >
                      <mat-icon class="vertical-align-baseline">
                        <svg
                          width="30"
                          height="35"
                          viewBox="0 0 55 55"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="27.5" cy="27.5" r="27.5" fill="#03C0FC" />
                          <path
                            d="M38.2143 29.2857H29.2857V38.2143C29.2857 39.1964 28.4821 40 27.5 40C26.5179 40 25.7143 39.1964 25.7143 38.2143V29.2857H16.7857C15.8036 29.2857 15 28.4821 15 27.5C15 26.5179 15.8036 25.7143 16.7857 25.7143H25.7143V16.7857C25.7143 15.8036 26.5179 15 27.5 15C28.4821 15 29.2857 15.8036 29.2857 16.7857V25.7143H38.2143C39.1964 25.7143 40 26.5179 40 27.5C40 28.4821 39.1964 29.2857 38.2143 29.2857Z"
                            fill="white"
                          />
                        </svg>
                      </mat-icon>
                      {{ 'COMMON.Add' | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                @if (contact.phoneNameError) {
                  <div class="text-red-600 error-msg">
                    {{ 'COMMON.Select a Phone Type' | translate }}
                  </div>
                }
              </div>
            }
            @if (flag == true && !notFromEQuote && fields?.type?.length) {
              <div class="mobile_name">
                <mat-form-field
                  id="country"
                  appearance="outline"
                  floatLabel="always"
                  [ngClass]="{
                    'mat-error-outline': titleRequired,
                    'mat-success-outline': !titleRequired,
                  }"
                >
                  <mat-select
                    id="num_name"
                    class="text-1"
                    [placeholder]="
                      isEquote
                        ? ('COMMON.Select a Phone' | translate)
                        : ('COMMON.Select And Add Name' | translate)
                    "
                    (selectionChange)="addFormOfContact($event)"
                    [(ngModel)]="contact.name"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="changephonenumberinput($event, i, 'name')"
                  >
                    <mat-option
                      class="text-1 f-poppins"
                      value=""
                      style="background-color: #fafafa"
                    >
                      {{
                        isEquote
                          ? ('COMMON.Select a Phone' | translate)
                          : ('CONTACT_PROFILE.Select_contact_name' | translate)
                      }}
                    </mat-option>
                    @for (
                      formContactList of fields?.type;
                      track formContactList;
                      let i = $index
                    ) {
                      <mat-option
                        id="option_num"
                        class="text-1 d-flex align-items-center overflow-visible f-poppins"
                        [value]="formContactList"
                        style="background-color: #fafafa"
                      >
                        <!-- <mat-icon class="vertical-align-baseline">
                      <img class="vertical-align-baseline" style="width: 25px;height: 20;" role="button"
                        src="assets/img/home/delete.svg"
                        (click)="removeItem(formContactList,'deleteformContact')">
                      </mat-icon> <i class="fa fa-edit edit-icon mr-2" style="color: #03C0FC;" (click)="updateSubcategories(formContactList,formContactListArr)"></i>-->
                        <div class="w-max" (click)="openBulkAction = false">
                          {{
                            getTranslatedText(
                              'CONTACT_PROFILE.' + formContactList
                            ) || formContactList
                          }}
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (contact.phoneNameError) {
                  <div class="text-red-600 error-msg">
                    {{ 'COMMON.Select a Phone Type' | translate }}
                  </div>
                }
              </div>
            }
            @if (flag == true && fields?.type?.length && notFromEQuoteOrg) {
              <div class="mobile_name">
                <mat-form-field
                  id="country"
                  appearance="outline"
                  floatLabel="always"
                >
                  <mat-select
                    id="num_name"
                    class="text-1"
                    [placeholder]="
                      isEquote
                        ? ('COMMON.Select a Phone' | translate)
                        : ('COMMON.Select And Add Name' | translate)
                    "
                    (selectionChange)="addFormOfContact($event)"
                    [(ngModel)]="contact.name"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="changephonenumberinput($event, i, 'name')"
                  >
                    <mat-option class="text-1" value="">
                      {{
                        isEquote
                          ? ('COMMON.Select a Phone' | translate)
                          : ('CONTACT_PROFILE.Select_contact_name' | translate)
                      }}
                    </mat-option>
                    @for (
                      formContactList of fields?.type;
                      track formContactList;
                      let i = $index
                    ) {
                      <mat-option
                        id="option_num"
                        class="text-1 d-flex align-items-center overflow-visible"
                        [value]="formContactList"
                      >
                        <!-- <mat-icon class="vertical-align-baseline">
                      <img class="vertical-align-baseline" style="width: 25px;height: 20;" role="button"
                        src="assets/img/home/delete.svg"
                        (click)="removeItem(formContactList,'deleteformContact')">
                      </mat-icon> <i class="fa fa-edit edit-icon mr-2" style="color: #03C0FC;" (click)="updateSubcategories(formContactList,formContactListArr)"></i>-->
                        <div class="w-max" (click)="openBulkAction = false">
                          {{
                            getTranslatedText(
                              'CONTACT_PROFILE.' + formContactList
                            ) || formContactList
                          }}
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (contact.phoneNameError) {
                  <div class="text-red-600 error-msg">
                    {{ 'COMMON.Select a Phone Type' | translate }}
                  </div>
                }
              </div>
            }
          </form>
        }
        <!-- <mat-form-field appearance="outline">
      <input
        matInput
        type="text"
        name="name"
        placeholder="{{'GENRIC_PLACEHOLDER.PHONE_NAME' | translate}}"
        value="{{ contact.name }}"
        (input)="changephonenumberinput($event, i, 'name')"
        />
    </mat-form-field> -->
        <div class="remove-arrow text-3 w-fit xs-2:hidden">
          <button
            class="btn"
            type="button"
            (click)="removeItem(i, 'phonenumber')"
          >
            <p class="d-inline-block remove-contact-number">
              <i class="fas fa-times"></i>
            </p>
          </button>
        </div>
      </div>
    }
    <!-- <div *ngIf="showPhoneError" class="text-red-600">Phone Number is Required</div> -->

    <button
      class="add-btn add-btn-plain-link mt-2 add-phn-num f-poppins text-left"
      (click)="addPhoneRow()"
      type="button"
    >
      <i class="fas fa-plus-circle"></i>
      {{ 'COMMON.Add Phone Number' | translate }}
    </button>

    <div class="col-lg-12">
      <ng-template #phoneNameDialog>
        <div class="phone-name-dialog cnt-dashboard">
          <div class="relative pt-5 px-2">
            <h2 class="text-1 fs-4 text-center">
              {{ 'COMMON.Phone Name' | translate }}
            </h2>
            <i
              type="button"
              (click)="closePhoneNameModal()"
              aria-label="Close"
              class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3 cursor-pointer"
            ></i>
          </div>
          <form
            [formGroup]="formOfContactForm1"
            (ngSubmit)="addFormOfContactList1()"
          >
            <div class="bg-gris-1 px-5 py-3">
              <label class="mb-2">
                {{ 'COMMON.NAME' | translate }}
                <span class="color-6">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                placeholder="{{
                  'GENRIC_PLACEHOLDER.Enter_phone_name' | translate
                }}"
                formControlName="name"
                (input)="duplicateNameError = false"
                [ngClass]="{
                  'is-invalid':
                    (formOfContactFormSubmit && formOfContact.name.errors) ||
                    duplicateNameError,
                  'is-valid':
                    formOfContactFormSubmit &&
                    formOfContact.name.valid &&
                    !duplicateNameError,
                }"
              />
              @if (duplicateNameError) {
                <div class="text-red-600 error-msg">
                  {{ 'COMMON.Phone name already exists' | translate }}
                </div>
              }
            </div>

            <div class="j-c-center mt-4 pb-4 d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-skyblue-s-1 standard-btn"
                (click)="closePhoneNameModal()"
              >
                {{ 'COMMON.Cancel' | translate }}
              </button>
              <button type="submit" class="btn btn-p-2 standard-btn mx-2">
                {{ 'COMMON.Add' | translate }}
              </button>
            </div>
          </form>
        </div>
      </ng-template>
    </div>
  </div>
</div>
